<template>
  <div class="container-fluid">
      <div class="row">
        <nav id="sidebarMenu" class="col-md-3 col-lg-2 d-md-block bg-light sidebar collapse">
          <div class="position-sticky pt-3">
            <h6 class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted">
              <span>Scenarios</span>
            </h6>
            
            <div class="accordion" id="accordionExample">
                <Poverty />
                <FoodInsecure />
             
            </div>

            <h6 class="sidebar-heading d-flex justify-content-between align-items-center px-3 mt-4 mb-1 text-muted">
              <span>Options</span>
            </h6>
            <ul class="nav flex-column mb-2">
              <li class="nav-item form-check">
                <input class="form-check-input" type="checkbox" value="" id="flexCheckChecked" @change="check($event)"/>
                <label class="form-check-label" for="flexCheckChecked">
                  Download simulation result (CSV)
                </label>
              </li>
              <li class="nav-item form-check">
                <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault"/>
                <label class="form-check-label" for="flexCheckDefault">
                  Download graph for main indicators (under construction)
                </label>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </div>
</template>
<script>
  import Poverty from '@/components/indicators/Poverty.vue'
  import FoodInsecure from '@/components/indicators/FoodInsecure.vue'
  import sourceData from '@/data.json'

  export default {
      components: { Poverty, FoodInsecure }
      ,
      methods: {
        check: function(e) {
          console.log("download csv")
          let filePath = "https://drive.google.com/u/2/uc?id=1jLlS-e40wuNCIkR134IziMq0kZlv4B_Q&export=download" //TODO: this is sample file, may be need to update new files for each scenario
          let link=document.createElement('a')
          link.href = filePath
          link.download = filePath.substr(filePath.lastIndexOf('/') + 1)
          link.click()
        },
        fetchMenu() {
          let data = JSON.parse(sourceData);
        }
      }
  }

</script>
